var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNz = function SvgIconNz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 12H12v-.031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.261V.001h-.002C5.372 0 0 5.372 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.787L8.474 6.26z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.565A12.06 12.06 0 0 0 1.565 6.07V12h3.13V4.695H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.525 7.738 6.26H6.262L12 12.001zM20.78 8.905l.26.797h.838l-.678.493.259.797-.678-.493-.678.493.259-.797-.678-.493h.838zM17.785 14.644l.389 1.195h1.257l-1.017.74.389 1.195-1.018-.739-1.017.739.389-1.196-1.017-.739h1.257zM17.899 5.252l.324.996h1.047l-.847.616.323.997-.847-.616-.848.616.324-.997-.848-.616h1.048zM15.015 8.87l.388 1.196h1.258l-1.018.739.39 1.196-1.018-.74-1.017.74.388-1.196-1.017-.74h1.257z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconNz;